export const INTRO_CONSTANTS = {
  title: "From Insight to Action — AI-Powered Network Observability at Scale",
  text: "Gain real-time visibility across hybrid infrastructures to detect anomalies before outages occur. Automate responses with OneMind’s AI-driven NMS platform for always-on network resilience.",
};
